import type { ContentGenerationProps } from "~/components/acquisition/RefundableFlightsBanner/contracts";

export const generateContent = (t: Function): ContentGenerationProps => ({
  title: t("prime.waitingPage.header.title"),
  subtitle: t("prime.waitingPage.header.subtitle"),
  body: {
    mainTitle: t("prime.waitingPage.description.mainTitle"),
    items: [
      {
        text: t("prime.waitingPage.description.first.text"),
        image: {
          alt: t("prime.waitingPage.description.first.text"),
          ED: {
            src: "/images/onefront/bluestone/ED/IsometricTimes-and-Dates/Calendar.svg",
          },
          OP: {
            src: "/images/onefront/bluestone/OP/IsometricTimes-and-Dates/Calendar.svg",
          },
          GO: {
            src: "/images/onefront/bluestone/GV/IsometricTimes-and-Dates/Calendar.svg",
          },
        },
      },
      {
        text: t("prime.waitingPage.description.second.text"),
        image: {
          alt: t("prime.waitingPage.description.second.text"),
          ED: {
            src: "/images/onefront/bluestone/ED/IsometricTravelProducts/ShieldWithCheck.svg",
          },
          OP: {
            src: "/images/onefront/bluestone/OP/IsometricTravelProducts/ShieldWithCheck.svg",
          },
          GO: {
            src: "/images/onefront/bluestone/GV/IsometricTravelProducts/ShieldWithCheck.svg",
          },
        },
        pill: t("prime.waitingPage.description.second.pill"),
      },
      {
        text: t("prime.waitingPage.description.third.text"),
        image: {
          alt: t("prime.waitingPage.description.third.text"),
          ED: {
            src: "/images/onefront/bluestone/ED/IsometricMiscellaneous/Couple.svg",
          },
          OP: {
            src: "/images/onefront/bluestone/OP/IsometricMiscellaneous/Couple.svg",
          },
          GO: {
            src: "/images/onefront/bluestone/GV/IsometricMiscellaneous/Couple.svg",
          },
        },
      },
    ],
  },
});
